import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { NotFoundError } from 'src/shared/error';

import type { PaginatedContextData, PaginatedData } from 'src/app/shared/contexts/asyncData';

import { TopicRecentPetitions } from './api.graphql';
import type { TopicRecentPetitionsQuery, TopicRecentPetitionsQueryVariables } from './api.graphql';
import type { TopicRecentPetitionsItem } from './types';

type TopicRecentPetitionsApiData = PaginatedData<
	TopicRecentPetitionsItem,
	{
		totalCount: number;
	}
>;

export type TopicRecentPetitionsData = PaginatedContextData<TopicRecentPetitionsApiData>;

export async function getData(
	{ gql: { fetch } }: UtilityContext,
	slug: string,
	cursor?: string,
): Promise<TopicRecentPetitionsApiData> {
	const { data } = await fetch<TopicRecentPetitionsQuery, TopicRecentPetitionsQueryVariables>({
		query: TopicRecentPetitions,
		variables: { cursor: cursor ?? null, slug },
		rejectOnError: true,
	});

	if (!data.topicPage) throw new NotFoundError();

	return {
		items: data.topicPage.recentPetitionsConnection.edges,
		cursor: data.topicPage.recentPetitionsConnection.pageInfo.endCursor,
		hasNextPage: data.topicPage.recentPetitionsConnection.pageInfo.hasNextPage,
		totalCount: data.topicPage.recentPetitionsConnection.totalCount,
	};
}
export async function getFirstPageData(utilityContext: UtilityContext, slug: string) {
	return getData(utilityContext, slug);
}
export async function getNextPageData(utilityContext: UtilityContext, cursor: string, slug: string) {
	return getData(utilityContext, slug, cursor);
}
